import axios from 'axios';

const API_URL = 'https://dev.aggelopoulos-sarantis.com';

export default {
    post(urlPath, data, headers) {
        return this.request(urlPath, headers, 'POST', data);
    },
    get(urlPath) {
        return this.request(urlPath, null, 'GET', null);
    },
    request(urlPath, headers, method, data) {
        method = method || 'POST';
        data = data || {};
        headers = headers || {};
        return new Promise((resolve, reject) => {
            axios({
                url: API_URL + urlPath,
                data,
                method,
                headers
            })
                .then(function(response) {
                    let contetType = response.headers['content-type'];
                    if (contetType && contetType.indexOf('application/json') > -1) {
                        return response.data;
                    } else {
                        resolve();
                    }
                })
                .then((data) => {
                    resolve(data);
                })
                .catch((error) => {
                    if (!error.response) {
                        // eventBus.$emit('sessionExpired');
                    }
                    reject(error);
                });
        });
    }
};
